import {
  Component,
  Input,
  OnChanges,
  Output,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { RuleMessageService } from '../../../services/rule-message.service';
import { JournalDigestDayGroup } from '../../../models/journal-digest.model';

@Component({
  selector: 'app-journal-digest-dialog',
  templateUrl: './journal-digest-dialog.component.html',
  standalone: false,
})
export class JournalDigestDialogComponent implements OnChanges {
  @Input() visible = false;
  @Input() filters: unknown;

  @Output() visibleChange = new EventEmitter<boolean>();

  loading = false;
  dayGroups: JournalDigestDayGroup[] = [];

  constructor(
    private ruleMessageService: RuleMessageService,
    private router: Router,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && this.visible) {
      this.loadDigest();
    }
  }

  onDialogHide(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  goToRule(ruleUid: string): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['factory/rule'], {
        queryParams: { id: ruleUid, tab: 'journal' },
      }),
    );
    window.open(url, '_blank');
  }

  private loadDigest(): void {
    this.loading = true;
    this.dayGroups = [];
    this.ruleMessageService
      .GetJournalDigest({ filters: this.filters ?? {} })
      .subscribe({
        next: (dayGroups) => {
          this.dayGroups = dayGroups;
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
  }
}
